module.exports = __webpack_public_path__ + "static/img/app-logo.92e907c3.png";